// https://medium.com/better-programming/show-and-hide-elements-with-rails-7s-stimulus-e988c35fbfb3
import { Controller } from "@hotwired/stimulus";

export class VisibilityController extends Controller {
  static targets = ["child", "visibilityButton", "icon", "container"];
  static outlets = ["visibility"];
  static classes = ["iconClosed", "iconOpen"];
  static values = {
    hidden: { type: Boolean, default: false },
    isParent: { type: Boolean, default: false },
  };
  connect() {
    this.syncIcon();
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add("hideable");
    }
    this.childTargets.forEach((child) => {
      child.classList.add("hideable-element");
    });
    if (this.hasIconBaseClass) {
      this.iconTarget.classList.toggle(this.iconOpenClass, this.hiddenValue);
      this.iconTarget.classList.toggle(this.iconClosedClass, !this.hiddenValue);
    }
  }

  toggleAll() {
    this.visibilityOutlets.forEach((child) => {
      child.toggle(event);
    });
    this.syncIcon();
  }

  setValueAll(event) {
    const value = event.params.value;
    this.dispatch("setAll", { detail: { value: value } });
    this.syncIcon();
  }
  toggle() {
    this.hiddenValue = !this.hiddenValue;
    this.sync();
  }

  setValue({ detail: { value } }) {
    if (this.isParentValue) return;

    this.hiddenValue = value;
    this.sync();
  }

  hide() {
    this.setValue(true);
  }
  show() {
    this.setValue(false);
  }

  startTransition(el, hidden, transitionDelay) {
    el.style.transitionDelay = transitionDelay;
    el.classList.toggle("show", !hidden);
    el.classList.toggle("hide", hidden);
  }

  sync() {
    const hidden = this.hiddenValue;
    this.containerTarget.classList.toggle("show", !hidden);
    this.containerTarget.classList.toggle("hide", hidden);
    this.childTargets.forEach((el, i) => {
      this.startTransition(el, hidden, "90ms");
    });
    this.syncIcon();
  }
  syncIcon() {
    if (this.isParentValue) return;

    const isHidden = this.hiddenValue;
    if (this.hasIconOpenClass)
      this.iconTarget.classList.toggle(this.iconOpenClass, !isHidden);
    if (this.hasIconClosedClass)
      this.iconTarget.classList.toggle(this.iconClosedClass, isHidden);
  }
}
